import { PAYMENT_STATUS } from "../helpers/Payment"
import { ExternalLinkDto } from "../integration/ExternalLink"
import Payment, { PaymentDto } from "./Payment"

type PaymentTransactionDtoAttributes = {
    externalLinks: ExternalLinkDto[]
    deleted: boolean
    amount: number
    currency: string
    payment: PaymentDto
    status: string
    refundableAmount: string
    paymentCreditMemo?: PaymentCreditMemoDto
}

export type PaymentTransactionDto = {
    id: string
    type: string
    attributes: PaymentTransactionDtoAttributes
}

type PaymentCreditMemoDtoAttributes = {
    payment: PaymentDto
}

export type PaymentCreditMemoDto = {
    id: string
    type: string
    attributes: PaymentCreditMemoDtoAttributes
}

export default class PaymentTransaction {
    private dto: PaymentTransactionDto
    constructor(dto: PaymentTransactionDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "payment-transactions"
    }

    getId(): string {
        return this.dto.id
    }

    getStatus(): string {
        return this.dto.attributes.status
    }

    getAmount(): number {
        return this.dto.attributes.amount
    }

    getCurrency(): string {
        return this.dto.attributes.currency
    }

    getPayment(): Payment {
        return new Payment(this.dto.attributes.payment)
    }

    getRefundableAmount(): number {
        return Number(this.dto.attributes.amount) + Number(this.getPayment().getTotalRefundedAmount())
    }

    isAssignedToMultipleDocuments(): boolean {
        return this.getAmount() < Number(this.getPayment().getAmount())
    }

    getExternalLinks(): ExternalLinkDto[] {
        return this.dto.attributes.externalLinks
    }

    isDeleted(): boolean {
        return this.dto.attributes.deleted
    }

    canBeDetachedOrVoided(): boolean {
        return this.isDetachable() || this.hasVoidablePendingPayment()
    }

    hasVoidablePendingPayment(): boolean {
        const payment = this.getPayment()
        switch (payment.getStatus()) {
        case PAYMENT_STATUS.PENDING:
            return this.getAmount() == parseFloat(payment.getAmount())
        default:
            return false
        }
    }

    isDetachable(): boolean {
        return this.getStatus() === PAYMENT_STATUS.PAID
    }

    getCreditMemoPayment(): Payment | undefined {
        if (this.dto.attributes.paymentCreditMemo?.attributes?.payment) {
            return new Payment(this.dto.attributes.paymentCreditMemo.attributes.payment)
        }
    }
}


// WEBPACK FOOTER //
// ./src/state/payment/PaymentTransaction.ts